import { useAuth } from 'helpers/authContext';
import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import ShellIcon, { IconName } from './ShellIcon';

export default function Sidebar() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const items: { to: string; label: string; icon: IconName; active: boolean }[] = [
    { to: '/clips', label: 'Clips', icon: 'clips', active: pathname === '/' || pathname.startsWith('/clips') },
    { to: '/new', label: 'Feed', icon: 'feed', active: ['/new', '/top', '/trending', '/foryou', '/following'].some(path => pathname.startsWith(path)) },
    { to: '/leaderboard', label: 'Ranking', icon: 'ranking', active: pathname.startsWith('/leaderboard') },
    { to: user ? `/wallet/${user}` : '/wallet', label: 'Wallet', icon: 'wallet', active: pathname.startsWith('/wallet') },
  ];
  return <nav className="sidebar-content speem-sidebar" aria-label="Primary navigation">
    <ul className="speem-sidebar-items">
      {items.map(item => <li key={item.label}><NavLink to={item.to} title={item.label} aria-current={item.active ? 'page' : undefined} className={`speem-sidebar-link ${item.active ? 'is-active' : ''}`}>
        <ShellIcon name={item.icon} /><span>{item.label}</span>
      </NavLink></li>)}
    </ul>
  </nav>;
}
